<template>
  <div class="comTable">
    <Table
      style="margin-top: 30px;"
      border
      :columns="columns1"
      :loading="modal_loading"
      :data="dataTable"
      show-summary
      :span-method="handleSpan"
      :summary-method="handleSummary"
    >
    </Table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal_loading: false,
      columns1: [
        {
          title: "胜任力类型",
          key: "key1",
          width: 260,
          align: "left"
        },
        {
          title: "胜任力评估项",
          key: "key2",
          align: "center"
        },
        {
          title: "目标分值",
          key: "key3",
          align: "center"
        },
        {
          title: "评估开始",
          key: "key4",
          align: "center"
        },
        {
          title: "评估完成",
          key: "key5",
          align: "center"
        },
        {
          title: "胜任力得分",
          key: "key6",
          align: "center"
        },
        {
          title: "差距",
          key: "key7",
          align: "center"
        }
      ],
      dataTable: [
        {
          key1: "1.已战略眼光思考问题和采取行动",
          key2: "商业头脑",
          key3: "3",
          key4: "4.47",
          key5: "3.87",
          key6: "3.87",
          key7: "0.87"
        },
        {
          key1: "1.已战略眼光思考问题和采取行动",
          key2: "决策质量",
          key3: "3",
          key4: "3.45",
          key5: "3.45",
          key6: "3.87",
          key7: "0.45"
        },
        {
          key1: "2.发挥自己和他人的能力已取得卓越绩效",
          key2: "追求结果",
          key3: "3",
          key4: "3.45",
          key5: "4.09",
          key6: "3.87",
          key7: "1.09"
        },
        {
          key1: "3.提升组织能力",
          key2: "人才培养",
          key3: "3",
          key4: "3.45",
          key5: "3.87",
          key6: "3.45",
          key7: "0.45"
        },
        {
          key1: "3.提升组织能力",
          key2: "慧眼识人",
          key3: "3",
          key4: "4.30",
          key5: "3.87",
          key6: "3.45",
          key7: "0.45"
        },
        {
          key1: "3.提升组织能力",
          key2: "激励他人",
          key3: "3",
          key4: "3.45",
          key5: "3.87",
          key6: "3.45",
          key7: "0.45"
        },
        {
          key1: "4.展示个人领导风格",
          key2: "管理勇气",
          key3: "3",
          key4: "4.09",
          key5: "3.87",
          key6: "4.09",
          key7: "1.09"
        }
      ]
    };
  },
  methods: {
    handleSpan({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0 && columnIndex === 0) {
        return {
          rowspan: 2,
          colspan: 1
        };
      } else if (rowIndex === 1 && columnIndex === 0) {
        return {
          rowspan: 0,
          colspan: 0
        };
      }
      if (rowIndex === 3 && columnIndex === 0) {
        return {
          rowspan: 3,
          colspan: 1
        };
      } else if (rowIndex === 4 && columnIndex === 0) {
        return {
          rowspan: 0,
          colspan: 0
        };
      } else if (rowIndex === 5 && columnIndex === 0) {
        return {
          rowspan: 0,
          colspan: 0
        };
      }
    },
    handleSummary({ columns, data }) {
      const sums = {};
      columns.forEach((column, index) => {
        const key = column.key;
        if (index === 0) {
          sums[key] = {
            key,
            value: ""
          };
          return;
        } else if (index === 2) {
          sums[key] = {
            key,
            value: ""
          };
          return;
        } else if (index === 6) {
          sums[key] = {
            key,
            value: ""
          };
          return;
        }
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[key] = {
            key,
            value: (v / 7).toFixed(2)
          };
        } else {
          sums[key] = {
            key,
            value: ""
          };
        }
      });
      return sums;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/bipage/components/ComTable.vue